import { Box, useTheme, alpha } from '@mui/material';
import { keyframes } from '@mui/material/styles';

/** เลื่อนแถบตาม Theme primary — ใช้ transform ให้แอนิเมชันทำงานได้แน่นอน */
const slideShimmer = keyframes`
  0% {
    transform: translate3d(-120%, 0, 0);
  }
  100% {
    transform: translate3d(320%, 0, 0);
  }
`;

type LoadingBarStripProps = {
  /** สำหรับ TopLoadingBar — ใส่ role/aria */
  withA11y?: boolean;
};

function LoadingBarStrip({ withA11y }: LoadingBarStripProps) {
  const theme = useTheme();
  const p = theme.palette.primary;
  const main = p.main;
  const light = p.light ?? p.main;
  const dark = p.dark ?? p.main;
  const isDark = theme.palette.mode === 'dark';

  const track = alpha(main, isDark ? 0.32 : 0.1);
  const edge = alpha(dark, isDark ? 0.35 : 0.2);
  const peak = light;

  return (
    <Box
      role={withA11y ? 'status' : undefined}
      aria-busy={withA11y ? true : undefined}
      aria-label={withA11y ? 'กำลังโหลด' : undefined}
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 2001,
        height: 3,
        overflow: 'hidden',
        bgcolor: track,
        pointerEvents: 'none'
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          height: '100%',
          width: '48%',
          minWidth: 72,
          background: `linear-gradient(
            90deg,
            ${edge} 0%,
            ${main} 35%,
            ${peak} 50%,
            ${main} 65%,
            ${edge} 100%
          )`,
          animation: `${slideShimmer} 1.15s cubic-bezier(0.45, 0, 0.35, 1) infinite`,
          willChange: 'transform',
          '@media (prefers-reduced-motion: reduce)': {
            animation: 'none',
            width: '100%',
            transform: 'none',
            background: main
          }
        }}
      />
    </Box>
  );
}

const Loader = () => <LoadingBarStrip />;

/**
 * แถบโหลดด้านบนจอ — สีตาม Theme primary (ใช้กับ block.handleLoad)
 */
export function TopLoadingBar({ active }: { active: boolean }) {
  if (!active) return null;
  return <LoadingBarStrip withA11y />;
}

export default Loader;
